var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
export class AspectRoleComment {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectRole() {
        return this.parent;
    }
    get aspect() {
        return this.aspectRole.aspect;
    }
    get isEditPopoverOpen() {
        return this.aspect.persistentAspect.entityTemp.flexMap.has('isEditPopoverOpen');
    }
    set isEditPopoverOpen(isOpen) {
        if (isOpen) {
            this.aspect.persistentAspect.entityTemp.flexMap.set('isEditPopoverOpen', true);
        }
        else {
            this.aspect.persistentAspect.entityTemp.flexMap.delete('isEditPopoverOpen');
        }
    }
    deleteComment() {
        this.aspect.persistentAspect.traits.clear();
        this.isEditPopoverOpen = false;
    }
    get legacyId() {
        return this.aspect.local.valueOf.commentLegacyId || undefined;
    }
    set legacyId(legacyId) {
        this.aspect.local.valueOf.commentLegacyId = legacyId;
    }
    fromLegacy(legacyCommentRow) {
        this.legacyId = legacyCommentRow.id;
        this.aspect.local.ensuredTraitOf.text.local.valueOf.textBasis = legacyCommentRow.comment;
    }
}
__decorate([
    computed
], AspectRoleComment.prototype, "isEditPopoverOpen", null);
__decorate([
    action.bound
], AspectRoleComment.prototype, "deleteComment", null);
